import React, { useEffect, useRef, useState } from 'react';

export default function ScrollReveal({
  children,
  className = '',
  delay = 0,
  duration = 800,
  distance = '30px',
  direction = 'up',
  threshold = 0.1,
}) {
  const [isIntersecting, setIsIntersecting] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsIntersecting(true);
          observer.unobserve(entry.target); // Only trigger once
        }
      },
      {
        threshold,
        rootMargin: '0px 0px -60px 0px', // Trigger slightly before the element is fully visible
      }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, [threshold]);

  const transformValue = () => {
    if (isIntersecting) return 'none';
    switch (direction) {
      case 'up':
        return `translateY(${distance})`;
      case 'down':
        return `translateY(-${distance})`;
      case 'left':
        return `translateX(${distance})`;
      case 'right':
        return `translateX(-${distance})`;
      default:
        return 'none';
    }
  };

  const style = {
    opacity: isIntersecting ? 1 : 0,
    transform: transformValue(),
    transition: `opacity ${duration}ms cubic-bezier(0.21, 1.02, 0.43, 1.01) ${delay}ms, transform ${duration}ms cubic-bezier(0.21, 1.02, 0.43, 1.01) ${delay}ms`,
  };

  return (
    <div ref={ref} style={style} className={className}>
      {children}
    </div>
  );
}
